import React, { useState } from "react";
import "../StuStyles/ChangePassword.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function StudentChangePassword({ onClose }) {
  const [showPass1, setShowPass1] = useState(false);
  const [showPass2, setShowPass2] = useState(false);

  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  const dummyOldPassword = "student123"; // old password validation

  const handleSubmit = (e) => {
    e.preventDefault();

    if (oldPass !== dummyOldPassword) {
      toast.error("❌ Old password is incorrect!");
      return;
    }

    if (newPass !== confirmPass) {
      toast.error("❌ New password and Confirm password do not match!");
      return;
    }

    toast.success("✔ Password changed successfully!");
    setTimeout(() => onClose(), 1000);
  };

  return (
    <div className="password-overlay">
      <ToastContainer position="top-center" autoClose={2000} theme="colored" />

      <form className="password-box" onSubmit={handleSubmit}>
        {/* Close Button */}
        <IoClose className="close-btn-change" onClick={onClose} />

        <label className="stupasswordlabel">Old Password</label>
        <div className="password-input">
          <input
            type={showPass1 ? "text" : "password"}
            placeholder="Old Password"
            required
            value={oldPass}
            onChange={(e) => setOldPass(e.target.value)}
          />
          <span onClick={() => setShowPass1(!showPass1)}>
            {showPass1 ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <label className="stupasswordlabel">New Password</label>
        <div className="password-input">
          <input
            type={showPass2 ? "text" : "password"}
            placeholder="New Password"
            required
            value={newPass}
            onChange={(e) => setNewPass(e.target.value)}
          />
          <span onClick={() => setShowPass2(!showPass2)}>
            {showPass2 ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <label className="stupasswordlabel">Confirm Password</label>
        <div className="password-input">
          <input
            type="password"
            placeholder="Confirm Password"
            required
            value={confirmPass}
            onChange={(e) => setConfirmPass(e.target.value)}
          />
          <span>
            <FaEyeSlash />
          </span>
        </div>

        <button className="password-submit-btn" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
}

export default StudentChangePassword;
